
export const customEndpoints = {
  GET_BY_PROCESS_ID: 'getByProcessId',
  GET_BY_ACTIVITY_ID: 'getByActivityId'
} as const;
